import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Criterio } from 'src/app/_models/meta';
import { BotonCriterioGroupComponent } from '../boton-criterio-group/boton-criterio-group.component';
import { RetroalimentacionCriterioControlComponent } from '../retroalimentacion-criterio-control/retroalimentacion-criterio-control.component';

@Component({
  selector: 'app-retroalimentacion-nivel-trabajo-criterios',
  standalone: false,
  templateUrl: './retroalimentacion-nivel-trabajo-criterios.component.html',
  styleUrls: ['./retroalimentacion-nivel-trabajo-criterios.component.scss', '../retroalimentacion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetroalimentacionNivelTrabajoCriteriosComponent implements OnInit {

  @Input()
  index: number;
  @Input()
  alumno: any;
  @Input()
  criterio: Criterio;
  @Input()
  eventoUnidadId: number;
  @Input()
  fecha$: Observable<string>;
  @Input()
  view: string;
  @Input()
  alumnos$: Observable<any>;
  @Input()
  mostrarAutoevaluacion$: Observable<boolean>;

  nivelForm = new UntypedFormControl(0);

  @ViewChild('criterioGroup', {static: false}) criterioGroup: RetroalimentacionCriterioControlComponent;

  constructor() { }

  ngOnInit(): void {
  }

}
